export default {
  header: {
    title: 'Project Management Panel',
    logOut: 'Logout'
  },
  navigation: {
    proj: {
      project: '工程管理',
      rsproj: '项目管理',
      projUser: '结算人管理',
      ctrAcct: '合同核算主体管理',
      rspCtrAcct: '合同核算主体管理New',
      settleUser: '结算人管理New',
      rspProject: '项目管理New'
    }
  },
  common: {
    toolBar: { // 操作
      nextStep: 'Next Step',
      previous: 'Previous',
      add: 'Add',
      reset: 'Reset',
      back: 'Back',
      commit: 'Submit',
      delete: 'Delete',
      jump: 'Go To',
      confirm: 'Confirm',
      loading: 'Loading...',
      empty: 'Empty',
      save: 'Save',
      cancel: 'Cancel',
      refresh: 'Refresh',
      exit: 'Exit',
      finish: 'Finish'
    },
    commonVar: {
      loadingSuccess: 'Login Success, Redirecting',
      action: 'Action',
      actionInfo: 'View',
      view: 'View',
      more: 'More',
      actionEdit: 'Edit',
      actionAdd: 'Add',
      actionCancel: 'Cancel',
      actionSave: 'Save',
      actionDelete: 'Delete',
      updateSuccess: 'Record Updated Successfully',
      notice: 'Notice',
      noticeContent: 'Are you sure you want to delete this record?',
      requiredFieldContent: 'Enter the required fields',
      delSuccess: 'Record Deleted Successfully',
      failed: 'Operation Failed',
      insertSuccess: 'Record Created Successfully',
      selectMonth: '月份',
      selectMonthPH: '选择月份',
      selectStartDt: '开始日期',
      selectStartDtPH: '选择开始日期',
      selectEndDt: '结束日期',
      selectEndDtPH: '选择结束日期',
      status: '状态',
      statusPH: '请选择状态',
      ctrAcctType: '主体类型',
      ctrAcctTypePH: '请选择主体类型',
      compId: '所属公司',
      compIdPH: '请选择公司',
      crtBy: '创建者',
      crtOn: '创建时间',
      updBy: '修改者',
      updOn: '修改时间',
      projStatusList: {
        TODO: '未开始',
        IN_DEV: '进行中',
        PAUSE: '暂停',
        CANCEL: '取消',
        DONE: '结束'
      },
      indList: {
        Y: '是',
        N: '不是'
      },
      statusList: {
        A: '显示',
        I: '隐藏'
      },
      ctrAcctTypeList: {
        PM: '项目管理',
        PRI: '总承包',
        SND: '自营分包'
      },
      projUserRoleList: {
        SETTLE: '普通结算人',
        MGR: '项目负责人',
        TAB: '制表人'
      },
      settleStatusList: {
        TODO: '未开始',
        IN_DEV: '进行中',
        PAUSE: '暂停',
        DONE: '已完工结算'
      },
      dateSearchMethodList: {
        MONTH: '按月查询',
        DATE_SCOPE: '按指定日期范围',
        PAUSE: '暂停',
        DONE: '已完工结算'
      }
    },
    queryBar: {
      searchBT: 'Search'
    }
  },
  module: {
    proj: {
      project: {
        addProjBtn: '新增项目',
        editProjSettleCollBtn: '栏目',
        confProjectBtn: '配置',
        confProjSettleUserBtn: '结算人',
        projName: '项目名称',
        projNamePH: '请输入项目名称',
        projDesc: '描述',
        projDescPH: '请输入项目描述',
        status: '状态',
        statusPH: '请选择状态',
        startDt: '开始日期',
        startDtPH: '请输入开始日期',
        endDt: '结束日期',
        endDtPH: '请输入结束日期',
        crtBy: '创建者',
        crtOn: '创建时间',
        updBy: '修改者',
        updOn: '修改时间',
        pageName: {
          projAdd: '新增项目',
          projDetail: '项目详情',
          projEdit: '编辑项目',
          projSettleCollEdit: '配置项目栏目',
          ptcpTransList: '结算人信息登记表',
          confProject: '项目初始化',
          settleSummary: '结算人汇总统计表'
        },
        validateInfo: {
          projNameRequired: '项目名称必填',
          startDtRequired: '开始日期必填'
        },
        settleColl: {
          // collName: '栏目名称',
        //
        },
        step: {
          confColumn: '配置栏目',
          confSettleUser: '配置结算人',
          confProjectMgr: '配置项目经理',
          confIncomeEntity: '配置收入栏实体',
          confPayment: '配置支付方式'
        }
      },
      ctracct: {
        info: {
          acctName: '主体名称',
          acctNamePH: '请输入主体名称',
          acctDesc: '描述',
          acctDescPH: '请输入描述',
          acctContact: '联系方式',
          acctContactPH: '请输入联系方式'
        },
        button: {
          addBtn: '新增核算主体'
        },
        pageName: {
          addPage: '新增核算主体',
          editPage: '编辑核算主体',
          viewPage: '核算主体详情'
        },
        validateInfo: {
          acctNameRequired: '主体名称必填',
          compIdRequired: '所属公司必填',
          typeRequired: '主体类型必填',
          statusRequired: '状态必填'
        }
      }
    },
    loginPage: { // 登录页面
      title: 'User Login',
      userName: 'Username',
      userNamePH: 'Enter your username',
      password: 'Password',
      passwordPH: 'Enter your password',
      verificationCode: 'Verification Code',
      enterCode: 'Enter Code',
      loginBtn: 'Login'
    },
    forgetPwdPage: {
      userName: 'Account Name:',
      userNamePH: 'Enter The Account Name',
      changePasswordSuccess: 'Successful Password Modification, Please Login Again!',
      changePassword: 'Change Password',
      enterOldPassword: 'Enter The Original Password:',
      enterOldPasswordPH: 'Please Enter The Original Password',
      enterNewPassword: 'Enter A New Password:',
      enterNewPasswordPH: 'Please Enter A New Password',
      confirmPassword: 'Confirm The New Password:',
      confirmPasswordPH: 'Please Enter The New Password Again',
      validateInfo: {
        userNameRep: 'Name Of Account Must Be Filled In',
        passwordReq: 'Password Required',
        passwordLenLimit: 'Password Must Be Between 6 And 16 Bits',
        passwordNotEquals: 'Two Inconsistent Passwords'
      },
      message: {
        canNotSame: 'Old And New Passwords Can Not Be The Same'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js